<div  class="loginForm">
    <form [formGroup]="loginFormGroup">
        <h2 class="text-center">Log ind</h2>
        <div *ngIf="wrongInput" class="alert alert-danger">
            {{wrongInputReason}}
        </div>
        <div class="form-group">
            <input class="form-control input-lg" placeholder="Brugernavn" formControlName="username">
        </div>
        <div class="form-group">
            <input class="form-control input-lg" type="password" placeholder="Kodeord" formControlName="password">
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg btn-block"  (click)="onSubmit()">Log ind</button>
        </div>
    </form>
    <div>
        <a [routerLink]="['/reset']">Glemt adgangskode?</a>
    </div>
</div>